; (function (global, factory) {
   typeof define === 'function' && define.amd ? define('MM/Components/Teams/ContentSearch/TeamRelatedProperties',['jquery', 'knockout', 'eventManager', 'matchHeight', 'slick'], factory) :
   typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require('jquery'), require('knockout'), require('eventManager'), require('matchHeight'), require('slick')) :
   console && console.error('TeamRelatedProperties does not support non-amd script loading.');
}(this/* window */, function ($, ko, eventManager /*, matchHeight */) {

    function TeamRelatedProperties(args) {

        Object.defineProperty(this, 'scope', { value: args.scope, enumerable: !0, configurable: !0, writable: !1 });
        Object.defineProperty(this, '$scope', { value: $(args.scope), enumerable: !1, configurable: !0, writable: !1 });
        Object.defineProperty(this, '$placeholder', { value: this.$scope.find('.result-placeholder'), enumerable: !0, configurable: !0, writable: !0 });

        Object.defineProperty(this, 'advisorsIds', { value: args.AdvisorsIds || [], enumerable: !0, configurable: !0, writable: !0 });
        Object.defineProperty(this, 'teamId', {value: args.TeamId, enumerable: !0, configurable: !0, writable: !1 });
        Object.defineProperty(this, 'tilesMaxCount', { value: args.TilesMaxCount, enumerable: !0, configurable: !0, writable: !0 });
        Object.defineProperty(this, 'searchRoot', { value: args.SearchRoot, enumerable: !0, configurable: !0, writable: !0 });
        Object.defineProperty(this, 'searchablePageTypes', { value: args.SearchablePageTypes || [], enumerable: !0, configurable: !0, writable: !0 });
        Object.defineProperty(this, 'searchApiUrl', { value: args.SearchApiUrl, enumerable: !0, configurable: !0, writable: !0 });
        //Object.defineProperty(this, 'searchServiceUnavailableMessage', { value: args.SearchServiceUnavailableMessage, enumerable: !0, configurable: !0, writable: !0 });
        Object.defineProperty(this, 'noSearchResultsText', { value: args.NoSearchResultsText, enumerable: !0, configurable: !0, writable: !0 });
        Object.defineProperty(this, 'timeoutToSearch', { value: args.TimeoutToSearch, enumerable: !0, configurable: !0, writable: !0 });
        Object.defineProperty(this, 'tileName', { value: args.TileName, enumerable: !0, configurable: !0, writable: !0 });

        Object.defineProperty(this, 'totalSearchResults', { value: 0, enumerable: !0, configurable: !0, writable: !0 });
        Object.defineProperty(this, 'isLoading', { value: ko.observable(!0), enumerable: !0, configurable: !0, writable: !1 });
        Object.defineProperty(this, 'isError', { value: ko.observable(!1), enumerable: !0, configurable: !0, writable: !1 });
        Object.defineProperty(this, 'properties', {value: ko.observableArray([]), enumerable: !0, configurable: !0, writable: !1 });
        Object.defineProperty(this, 'showSeeMoreTile', { value: args.ShowSeeMoreTile, enumerable: !0, configurable: !0, writable: !0 });
        

        this.suspendedComponentInit();

        ko.applyBindings(this, this.scope);
    }

    TeamRelatedProperties.prototype.suspendedComponentInit = function suspendedComponentInit() {
        setTimeout(this.getData.bind(this), this.timeoutToSearch);
    }

    /*
     * Get related objects to the current page
     */
    TeamRelatedProperties.prototype.getData = function () {
        $.ajax({
            url: this.searchApiUrl,
            type: "POST",
            data: {
                relatedAgentsIds: this.advisorsIds,
                teamId: this.teamId,
                pageSize: this.tilesMaxCount,
                searchRootId: this.searchRoot,
                searchablePageTypes: this.searchablePageTypes,
                tileName: this.tileName,
            }
        }).done(this.appendTiles.bind(this))
          .done(eventManager.trigger.bind(this, 'team_properties_featured:resultsLoaded'))
          .fail(this.onError.bind(this));
    };

    TeamRelatedProperties.prototype.reset = function reset() {
        this.totalSearchResults = 0;
    }

    /*
     * Handle success response from the related properties service
     * Update available tiles and determine should Keep Exploring tile be visible
     */
    TeamRelatedProperties.prototype.appendTiles = function appendTilesRelatedProperties(data) {
        if (!data || !(data.Properties instanceof Array) || !('TotalSearchResults' in data) || (data.Properties instanceof Array && !data.Properties.length)) {
            console && console.log instanceof Function && console.log(this.noSearchResultsText);
            this.$scope.hide();
            // hide the outer most block so styling will be hidden as well
            var parentsAxe = this.$scope.parentsUntil('.page-wrapper');
            var outMostEl = parentsAxe[parentsAxe.length - 1];
            if (outMostEl) $(outMostEl).hide();
            return;
        }

        this.reset();
        this.isLoading(!1);

        // apply properties from the response
        this.properties.removeAll();
        data.Properties.forEach(function (property) { this.properties.push(property); }, this);
        this.totalSearchResults = data.TotalSearchResults;

        new Promise(function (resolve, reject) { setTimeout(resolve, 100/* knockout magic number to wait til it bind */); }).then((function () {
            this.$scope.find('.featured-list li .mm-tile').matchHeight();
            this.$scope.find('.featured-list li .mm-tile > a').prop('target', '_blank');
            var $propData = this.$scope.find('.mm-tile .mm-property-wrapper p:not(.mm-location)');
            if (!$propData.length) {
                // do nothing, if that is not a team properties page
                return;
            }
            $propData.each(function (index, el) {
                el.innerHTML = el.innerText.replace(/.*\:/ig, '<span>$&</span>')
            });

        }).bind(this));

    }

    TeamRelatedProperties.prototype.onError = function onError(reason) {
        console && console.log instanceof Function && console.log("error occured during fetching related objects to the current page.", reason);
        this.isLoading(!1);
        this.isError(!0);
    }

    TeamRelatedProperties.prototype.isKeepExploringVisible = function isKeepExploringVisible() {
        return this.totalSearchResults > this.tilesMaxCount;
    }

    TeamRelatedProperties.init = function initRelatedPanel(args) {
        var entity = new TeamRelatedProperties(args);
        return entity;
    }

    return TeamRelatedProperties;
}));
